import React, { useEffect, useState, useRef } from "react";
import "./Kb.css";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../api/axios";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";

/* ✅ IMPORT YOUR ALREADY-MADE POPUP COMPONENT — UNCHANGED */
import AttachmentMethodsPage from "./Knowladgebase/attachmentMethods";
import Sidebarnew from "./NewUI/Sidebarnew";
import Navigationnew from "./NewUI/Navigationnew";

const Kb = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ ALL STATE UNCHANGED
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [department, setDepartment] = useState("HR");
  const [verified, setVerified] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [tableData, setDocuments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedUpdated, setSelectedUpdated] = useState("");
  const [openActionRow, setOpenActionRow] = useState(null);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
  const [selectedRows, setSelectedRows] = useState([]);
  const [search, setSearch] = useState("");
  const [canWrite, setCanWrite] = useState(false);
  const [pageLoading, setPageLoading] = useState(true); // New state for overall page loading
  const [linkStatus, setLinkStatus] = useState("");
  const [mostUsedDoc, setMostUsedDoc] = useState("Loading...");
  const [docDetailModal, setDocDetailModal] = useState(false);
  const [docDetail, setDocDetail] = useState(null);
  const [docDetailLoading, setDocDetailLoading] = useState(false);

  // ✅ PAGINATION: changed to 50 rows per page
 // ✅ PAGINATION: Dynamic rows per page
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  // ✅ ADD THIS NEW STATE
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [docsToDelete, setDocsToDelete] = useState([]);
  const isFirstMount = useRef(true);  // ← add here

  // ✅ ALL EFFECTS UNCHANGED
//  useEffect(() => {
//   const loadInitialData = async () => {
    
//     const params = new URLSearchParams(location.search);
//     const ls = params.get("linkStatus");
//     if (ls) setLinkStatus(ls);

//     setPageLoading(true);
//     await Promise.all([
//       fetchDocuments(ls),  
//       fetchPermissions(),
//       fetchMostUsedDoc()
//     ]);
//     setPageLoading(false);
//   };
//   loadInitialData();
// }, []);

  // useEffect(() => {
  //   const loadInitialData = async () => {
  //     setPageLoading(true);
  //     await Promise.all([
  //       fetchDocuments(),
  //       fetchPermissions(),
  //       fetchMostUsedDoc()
  //     ]);
  //     setPageLoading(false);
  //   };
  //   loadInitialData();
  // }, []); // Empty dependency array to run once on mount

  const fetchMostUsedDoc = async () => { // No individual loading state here, handled by pageLoading
    try {
      const res = await api.get("/kb/most-used");
      setMostUsedDoc(res.data.fileName);
    } catch (err) {
      console.error("Fetch most used doc error:", err);
      setMostUsedDoc("N/A");
    } // No finally block to set loading, as it's handled by pageLoading
  };

 const fetchDocuments = async (linkStatusOverride) => {
  try {
    const activeLinkStatus = linkStatusOverride !== undefined ? linkStatusOverride : linkStatus;
    const res = await api.get(
      `${process.env.REACT_APP_API_BASE_URL}/documents`,
      {
        params: { search, department: selectedDepartment, status: selectedStatus, updated: selectedUpdated, linkStatus: activeLinkStatus },
        headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
      }
    );
    setDocuments(res.data.documents);
  } catch (err) {
    console.error("Fetch docs Error:", err);
  }
};
  const fetchPermissions = async () => { // No individual loading state here, handled by pageLoading
    try {
      const res = await api.get("/user-roles/me");
      const role = res.data;
      if (role.isAdmin) { setCanWrite(true); return; }
      if (role && !role.noRoleDefined) {
        const writeStr = role.write_access || "";
        const bothStr = role.both_access || "";
        setCanWrite(writeStr.includes("Kb") || bothStr.includes("Kb"));
      } else {
        setCanWrite(true);
      }
    } catch (err) {
      console.error("Permission check failed");
      setCanWrite(false);
    } // No finally block to set loading, as it's handled by pageLoading
  };

useEffect(() => {
  const loadInitialData = async () => {
    const params = new URLSearchParams(location.search);
    const ls = params.get("linkStatus") || "";
    setLinkStatus(ls);
    setPageLoading(true);
    await Promise.all([fetchDocuments(ls), fetchPermissions(), fetchMostUsedDoc()]);
    setPageLoading(false);
  };
  loadInitialData();
}, []);

useEffect(() => {
  if (isFirstMount.current) {
    isFirstMount.current = false;
    return;
  }
  fetchDocuments(linkStatus);
}, [search, selectedDepartment, selectedStatus, selectedUpdated, linkStatus]);

useEffect(() => {
  setCurrentPage(1);
}, [search, selectedDepartment, selectedStatus, selectedUpdated, linkStatus]);

  // ✅ UNCHANGED — doc detail modal
  const handleDocumentClick = async (docId) => {
    setDocDetailLoading(true);
    setDocDetailModal(true);
    setDocDetail(null);
    try {
      const res = await api.get(`/documents/${docId}`);
      setDocDetail(res.data);
    } catch (err) {
      console.error("Failed to fetch doc detail:", err);
    } finally {
      setDocDetailLoading(false);
    }
  };

  // ✅ ALL HANDLERS UNCHANGED
  const handleUpload = async () => {
    if (!file) {toast.error("Please select a document"); return; }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("workspaceId", "a2f1d7c2-9c3c-4d1a-9c6f-111111111111");
    formData.append("sourceType", "kb");
    formData.append("sourceId", uuidv4());
    formData.append("department", department);
    formData.append("verified", verified);
    try {
      setUploading(true);
      await api.post(`${process.env.REACT_APP_API_BASE_URL}/embeddings/upload`, formData, { headers: { "Content-Type": "multipart/form-data" } });
     toast.success("Document uploaded successfully");
      setIsModalOpen(false);
      setFile(null);
      setVerified(false);
      setDepartment("HR");
      fetchDocuments();
    } catch (err) {
      console.error("Upload error:", err);
toast.error("Failed to upload document");    } finally {
      setUploading(false);
    }
  };

const handleVerify = async (docId, currentStatus) => {
    try {
      const ids = selectedRows.length > 0 ? selectedRows : [docId];

      if (ids.length === 0) {
       toast.warning("Select at least one document");
        return;
      }

      const newStatus = !currentStatus; // 🔥 toggle

      // 🔥 FIX 1: Remove "/api" so it doesn't become /api/api/documents/verify
      await api.put("/documents/verify", {
        ids,
        verified: newStatus
      });

     toast.success(
  newStatus
    ? "Document verified successfully"
    : "Document unverified successfully"
);

      setSelectedRows([]);
      fetchDocuments();

    } catch (err) {
      console.error("Verify toggle failed", err);
   toast.error("Operation failed");
    }
  };

  // ✅ REPLACE your old handleDelete with these three functions:
  const handleDelete = (docId) => {
    const ids = selectedRows.length > 0 ? selectedRows : [docId];
    setDocsToDelete(ids);
    setDeleteModalVisible(true);
  };

  const confirmDelete = async () => {
    if (docsToDelete.length === 0) return;
    try {
      await api.post("/documents/delete", { ids: docsToDelete });
    toast.success("Document deleted successfully");
      setSelectedRows([]);
      fetchDocuments();
    } catch (err) {
      console.error("Delete failed", err);
    toast.error("Delete failed");
    } finally {
      setDeleteModalVisible(false);
      setDocsToDelete([]);
    }
  };

  const cancelDelete = () => {
    setDeleteModalVisible(false);
    setDocsToDelete([]);
  };
const handleView = async (doc) => {
  try {
    const res = await api.get(`/documents/${doc.id}/view`);
    window.open(res.data.url, "_blank");
  } catch (err) {
    console.error("View failed:", err);
   toast.error("Unable to open document");
  }
};

const handleDownload = async (doc) => {
  try {
    const res = await api.get(`/documents/${doc.id}/download`);
    const { url, fileName } = res.data;

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "document";
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err) {
    console.error("Download failed:", err);
   toast.error("Unable to download file");
  }
};

  const handleSelectAll = () => {
    if (selectedRows.length === tableData.length) setSelectedRows([]);
    else setSelectedRows(tableData.map((doc) => doc.id));
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) => prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]);
  };

  useEffect(() => { setSelectedRows([]); }, [tableData]);

  const handleClearFilters = () => {
    setSearch("");
    setSelectedDepartment("");
    setSelectedStatus("");
    setSelectedUpdated("");
    setLinkStatus("");
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleString();
  };

  const formatSize = (bytes) => {
    if (!bytes) return "-";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  // ✅ PAGINATION — 50 per page
  const totalPages = Math.ceil(tableData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedData = tableData.slice(startIndex, endIndex);

  // ✅ UNCHANGED computed values
  const totalDocs = tableData.length;
  const verifiedDocs = tableData.filter((doc) => doc.verified).length;
  const unverifiedDocs = tableData.filter((doc) => !doc.verified).length;
  const uniqueSources = [
  ...new Set(
    tableData
      .map((doc) => doc.source_type)
      .filter(Boolean)
  ),
].length;

return (
  <div className="db-page-layout">

    <aside className="db-sidebar-shell">
      <Sidebarnew />
    </aside>

    <div className="db-main-wrapper">

      <div className="db-topbar-shell">
        <Navigationnew
          setArtifactsOpen={() => {}}
          artifactsOpen={false}
        />
      </div>

      <div className="kb-wrap">
 <div className="kb-page-header-row">

  <div className="kb-page-header">
    <h1 className="kb-page-title">Knowledge Base</h1>

    <p className="kb-page-description">
      Manage documents and data sources for your agents.
    </p>
  </div>

  {canWrite && (
    <button
      className="kb-add-source-btn"
      onClick={() => setIsModalOpen(true)}
    >
      <img src="/images/link_icon.svg" alt="link" />
      Add Source
    </button>
  )}

</div>
<div className="kb-stats-grid">
  

  <div className="kb-stat-card">
    <div className="kb-stat-top">
      <span className="kb-stat-label">TOTAL DOCUMENTS</span>
<div className="kb-stat-icon">
  <img src="/images/kb1.svg" alt="" />
</div>
    </div>

    <h2 className="kb-stat-value">{totalDocs}</h2>
  </div>

  <div className="kb-stat-card">
    <div className="kb-stat-top">
      <span className="kb-stat-label">VERIFIED</span>

      <div className="kb-stat-icon">
        <img src="/images/kb2.svg" alt="" />
      </div>
    </div>

    <h2 className="kb-stat-value">{verifiedDocs}</h2>
  </div>

  <div className="kb-stat-card">
    <div className="kb-stat-top">
      <span className="kb-stat-label">UNVERIFIED</span>

      <div className="kb-stat-icon ">
        <img src="/images/kb3.svg" alt="" />
      </div>
    </div>

    <h2 className="kb-stat-value">{unverifiedDocs}</h2>
  </div>

  <div className="kb-stat-card">
    <div className="kb-stat-top">
      <span className="kb-stat-label">SOURCES</span>

      <div className="kb-stat-icon">
        <img src="/images/kb4.svg" alt="" />
      </div>
    </div>

    <h2 className="kb-stat-value">{uniqueSources}</h2>
  </div>

</div>

      {/* ✅ UNCHANGED — Doc Detail Modal */}
      {docDetailModal && (
        <>
          <div className="modal-overlay" onClick={() => setDocDetailModal(false)} />
          <div className="doc-detail-modal shadow">
            <div className="doc-detail-logo-banner" />
            <div className="modal-header-top" style={{ padding: "16px 32px 0 28px", marginBottom: "0" }}>
              <h6 className="modal-title-sharp">Document Details</h6>
              <i className="bi bi-x-lg close-icon-sharp" onClick={() => setDocDetailModal(false)} />
            </div>
            <hr className="modal-header-line" style={{ margin: "12px 32px 16px 28px" }} />
            <div className="doc-detail-scroll-inner">
              {docDetailLoading ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status" />
                  <p className="mt-2 text-muted small">Loading details...</p>
                </div>
              ) : docDetail ? (
                <div className="doc-detail-body">
                  <div className="doc-detail-grid">
                    {[
                      ["Document Name", docDetail.file_name],
                      ["File Type", docDetail.file_type],
                      ["File Size", formatSize(docDetail.file_size)],
                      ["Department", docDetail.department],
                      ["Source", docDetail.source_type],
                      ["Source ID", docDetail.source_id],
                      ["Workspace ID", docDetail.workspace_id],
                      ["Total Chunks", docDetail.total_chunks ?? "-"],
                      ["Storage Path", docDetail.storage_path],
                      ["Document ID", docDetail.id],
                      ["Uploaded At", formatDate(docDetail.created_at)],
                      ["User ID", docDetail.user_id],
                    ].map(([label, value]) => (
                      <div className="doc-detail-row" key={label}>
                        <span className="doc-detail-label">{label}</span>
                        <span className="doc-detail-value">{value || "-"}</span>
                      </div>
                    ))}
                    <div className="doc-detail-row">
                      <span className="doc-detail-label">Verification Status</span>
                      <span className={`doc-detail-badge ${docDetail.verified ? "badge-verified" : "badge-unverified"}`}>
                        {docDetail.verified ? "✓ Verified" : "✗ Not Verified"}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <p className="text-muted text-center py-3">Failed to load document details.</p>
              )}
            </div>
            
          </div>
          
        </>
      )}

      {/* ✅ UNCHANGED — Attachment Modal */}
      {isModalOpen && (
        <AttachmentMethodsPage onClose={() => { setIsModalOpen(false); fetchDocuments(); }} />
      )}

      {/* ── TOP BAR ── */}
      <div className="kb-topbar">
        <div className="kb-topbar-left">
          <div className="kb-search-wrap">
            <i className="bi bi-search kb-search-icon" />
            <input
              type="text"
              className="kb-search-input"
              placeholder="Search agents by name or description..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="kb-topbar-right">
          {/* Department filter */}
          <div className="kb-filter-group">
            <span className="kb-filter-label">Department</span>
            <div className="kb-select-wrap">
              <select className="kb-select" value={selectedDepartment} onChange={(e) => setSelectedDepartment(e.target.value)}>
                <option value="">All Departments</option>
                <option value="HR">HR</option>
                <option value="Finance">Finance</option>
                <option value="Operations">Operations</option>
                <option value="IT">IT</option>
              </select>
              <i className="bi bi-chevron-down kb-select-arrow" />
            </div>
          </div>

          {/* Updated filter */}
          <div className="kb-filter-group">
            <span className="kb-filter-label">Updated</span>
            <div className="kb-select-wrap">
              <select className="kb-select" value={selectedUpdated} onChange={(e) => setSelectedUpdated(e.target.value)}>
                <option value="">Any Time</option>
                <option value="today">Today</option>
                <option value="7days">Last 7 Days</option>
                <option value="30days">Last 30 Days</option>
              </select>
              <i className="bi bi-chevron-down kb-select-arrow" />
            </div>
          </div>

          {/* Link Status filter */}
          <div className="kb-filter-group">
            <span className="kb-filter-label">Link Status</span>
            <div className="kb-select-wrap">
              <select
  className="kb-select"
  value={linkStatus}
  onChange={(e) => setLinkStatus(e.target.value)}
>
  <option value="">All</option>

  <option value="linked">Linked</option>

  <option value="unlinked">Unlinked</option>
</select>
              <i className="bi bi-chevron-down kb-select-arrow" />
            </div>
          </div>

          {/* Status filter */}
          <div className="kb-filter-group">
            <span className="kb-filter-label">Status</span>
            <div className="kb-select-wrap">
              <select className="kb-select" value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
                <option value="">All Status</option>
                <option value="verified">Verified</option>
                <option value="not_verified">Not Verified</option>
              </select>
              <i className="bi bi-chevron-down kb-select-arrow" />
            </div>
          </div>

          {/* Clear filters */}
          <button className="kb-clear-btn" onClick={handleClearFilters} title="Clear filters">
            <img src="/images/Clear filters.svg" alt="Clear" style={{ width: '16px', height: '16px' }} />
          </button>

          
        </div>
        
      </div>

      {/* ── TABLE ── */}
      <div className="kb-table-wrap">
        <table className="kb-table">
          <thead>
            <tr>
              {/* <th className="kb-th-cb">
                <input
                  type="checkbox"
                  className="kb-checkbox"
                  checked={tableData.length > 0 && selectedRows.length === tableData.length}
                  onChange={handleSelectAll}
                />
              </th> */}
              <th>Document Name</th>
              <th>Department</th>
              <th>Source</th>
              <th>Agent</th>
              <th>Version</th>
              <th>Verification Status</th>
              <th>Last Updated</th>
              <th className="kb-th-action">Step Progress</th>
            </tr>
          </thead>
          <tbody>
            {pageLoading ? (
              // Skeleton rows
              [...Array(rowsPerPage)].map((_, index) => (
                <tr key={index} className="placeholder-glow">
                  <td>
                    <div className="kb-doc-name">
                      <div className="kb-doc-icon placeholder bg-secondary rounded-circle" style={{ width: '24px', height: '24px' }}></div>
                      <span className="kb-doc-link placeholder bg-secondary col-8"></span>
                    </div>
                  </td>
                  <td><div className="placeholder bg-secondary col-6"></div></td>
                  <td><div className="placeholder bg-secondary col-4"></div></td>
                  <td><div className="placeholder bg-secondary col-4"></div></td>
                  <td><div className="placeholder bg-secondary col-3"></div></td>
                  <td><div className="placeholder bg-secondary col-5"></div></td>
                  <td><div className="placeholder bg-secondary col-7"></div></td>
                  <td className="kb-td-actions">
                    <div className="kb-icon-btn placeholder bg-secondary rounded-circle" style={{ width: '24px', height: '24px' }}></div>
                  </td>
                </tr>
              ))
            ) : paginatedData.length === 0 ? (
              <tr>
                <td colSpan="8" className="kb-empty">No documents found.</td>
              </tr>
            ) : (
              paginatedData.map((doc, i) => (
                <tr key={doc.id} className={selectedRows.includes(doc.id) ? "kb-row-selected" : ""}>
                  {/* <td className="kb-td-cb">
                    <input
                      type="checkbox"
                      className="kb-checkbox"
                      checked={selectedRows.includes(doc.id)}
                      onChange={() => handleRowSelect(doc.id)}
                    />
                  </td> */}
                  <td>
                    <div className="kb-doc-name" onClick={() => handleDocumentClick(doc.id)}>
                      <img src="/images/pdfs.svg" alt="" className="kb-doc-icon" onError={(e) => e.target.style.display='none'} />
                      <span className="kb-doc-link">{doc.file_name}</span>
                    </div>
                  </td>
                  <td>{doc.department}</td>
                  <td className="kb-td-upper">{doc.source_type}</td>
                  <td>{doc.agents || "-"}</td>
                  <td>{doc.version || "-"}</td>
                  <td>
                    <span className={`kb-status-pill ${doc.verified ? "kb-status-verified" : "kb-status-unverified"}`}>
                      {doc.verified ? "VERIFIED" : "NOT VERIFIED"}
                    </span>
                  </td>
                  <td className="kb-td-date">{formatDate(doc.created_at)}</td>
     <td className="kb-td-actions">

    <button
      className="kb-icon-btn"
      onClick={(e) => {
        if (openActionRow === i) { setOpenActionRow(null); return; }
        const rect = e.currentTarget.getBoundingClientRect();
        setDropdownPos({ top: rect.bottom + 4, left: rect.right - 150 });
        setOpenActionRow(i);
      }}
    >
      <i className="bi bi-three-dots-vertical"></i>
    </button>

    {openActionRow === i && (
      <div className="action-menu" style={{ position: "fixed", top: dropdownPos.top, left: dropdownPos.left, zIndex: 99999 }}>
<div className="action-menu-item" onClick={() => { handleVerify(doc.id, doc.verified); setOpenActionRow(null); }}>
    {doc.verified ? "Unverify" : "Verify"}
</div>   
<div className="action-menu-item" onClick={() => { handleView(doc) }}>view</div>
   <div className="action-menu-item text-muted">Update (Disabled)</div>
        <div className="action-menu-item text-danger" onClick={() => { handleDelete(doc.id); setOpenActionRow(null); }}>Delete</div>
      </div>
    )}

    {/* <button
      className="kb-icon-btn"
      title="View"
      onClick={() => handleDocumentClick(doc.id)}
    >
      <i className="bi bi-eye" />
    </button> */}

</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* ── PAGINATION FOOTER ── */}
        {/* ── PAGINATION FOOTER ── */}
       {/* ── PAGINATION FOOTER ── */}
        {tableData.length > 0 && (
          <div className="kb-pagination">
            <div className="kb-pagination-info" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <span>
                Showing rows {startIndex + 1}–{Math.min(endIndex, tableData.length)} of {tableData.length}
              </span>
              
              {/* Dynamic Limit Selector */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span>per page:</span>
                <select 
                  style={{ width: '65px', fontSize: '12px', padding: '3px 6px', borderRadius: '6px', border: '1px solid #E2E8F0', outline: 'none', cursor: 'pointer' }}
                  value={rowsPerPage}
                  onChange={(e) => {
                    setRowsPerPage(Number(e.target.value));
                    setCurrentPage(1); 
                  }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
            </div>

            {/* 👇 RESTORED MISSING ARROWS AND PROPER CLOSING TAGS 👇 */}
            <div className="kb-pagination-arrows">
              <button
                className="kb-page-arrow"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                <i className="bi bi-chevron-left" />
              </button>
              <button
                className="kb-page-arrow"
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                <i className="bi bi-chevron-right" />
              </button>
            </div>
          </div>
        )}
      </div>
{/* ✅ ADD THIS MODAL UI JUST BEFORE THE LAST CLOSING DIV OF KB */}
           {deleteModalVisible && (
        <div className="custom-delete-overlay" onClick={cancelDelete}>
          <div
            className="custom-delete-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="custom-delete-header">
              <div className="delete-icon-circle">
                <img src="/images/binn.svg" alt="warning" />
              </div>

              <h5>
                Delete Document
                {docsToDelete.length > 1 ? "s" : ""}?
              </h5>
            </div>

            <div className="custom-delete-body">
              <p>
                Are you sure you want to delete{" "}
                <strong>{docsToDelete.length}</strong> document
                {docsToDelete.length > 1 ? "s" : ""}?
              </p>

              <p className="delete-warning">
                This action is permanent and cannot be undone.
              </p>
            </div>

            <div className="custom-delete-footer">
              <button
                className="btn-cancel-delete"
                onClick={cancelDelete}
              >
                Cancel
              </button>

              <button
                className="btn-confirm-delete"
                onClick={confirmDelete}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
       </div>
    </div>
  </div>
);
};
export default Kb;